import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function ProductCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slides = [{
    img: 'https://cdn.magicpatterns.com/uploads/5BECy4yqhaByXVqabPsQjd/365_Cenas_-_Portada.png',
    title: 'Portada Principal'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/vW8N4NKAQx4Hae1yYYbjAN/slide_2.png',
    title: 'Vista Interior (Recetas)'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/mADajyaFAxYxKDLps4Rz3t/slide_3.png',
    title: 'Bono 1 — Lista del Super Inteligente'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/fVKCdqybSccMX4kcV1Vv2G/slide_4.png',
    title: 'Bono 2 — Checklist Nocturna'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/4c8qP6U8iQsVy59M1hZgxg/slide_5.png',
    title: 'Bono 3 — Guía de Desayunos'
  }];
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);
  };
  return <div className="relative w-full max-w-3xl mx-auto mb-16" data-id="element-130">
      <div className="overflow-hidden rounded-xl bg-black/20 shadow-2xl aspect-[4/3] md:aspect-[16/9] relative" data-id="element-131">
        <AnimatePresence mode="wait" data-id="element-132">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -50
        }} transition={{
          duration: 0.3
        }} className="absolute inset-0 flex flex-col items-center justify-center p-4" data-id="element-133">
            <img src={slides[currentIndex].img} alt={slides[currentIndex].title} className="max-h-[80%] w-auto object-contain rounded-lg shadow-lg" data-id="element-134" />
            <p className="text-ivory mt-4 font-medium text-lg text-center" data-id="element-135">
              {'Conoce Nuestro Producto \u27A1\uFE0F'}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>

      <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 text-white p-2 rounded-full backdrop-blur-sm transition-colors" aria-label="Anterior slide" data-id="element-136">
        <ChevronLeft className="w-6 h-6" data-id="element-137" />
      </button>
      <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 text-white p-2 rounded-full backdrop-blur-sm transition-colors" aria-label="Siguiente slide" data-id="element-138">
        <ChevronRight className="w-6 h-6" data-id="element-139" />
      </button>

      <div className="flex justify-center gap-2 mt-6" data-id="element-140">
        {slides.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-2.5 h-2.5 rounded-full transition-colors ${i === currentIndex ? 'bg-gold' : 'bg-white/30'}`} aria-label={`Ir al slide ${i + 1}`} data-id="element-141" />)}
      </div>
    </div>;
}